'use client';
import CheckBoxGroup from '@/components/shared/checkbox-group/checkbox-group.component';
import CustomCheckBox from '@/components/shared/custom-check-box/custom-check-box.component';
import Typography from '@/components/shared/typography/typography.component';
import { useState } from 'react';
import { useTranslation } from '@/hook';
import { ArrowDarkDown } from '../../../../public/Images';
import { MakeFilterUiOject } from '@/types';
import Image from 'next/image';

const FilterMultiSelect = ({
    text,
    selected,
    checkBoxClicked,
    value,
    img,
    dropdownData,
}: {
    text: string;
    value: string;
    selected: boolean;
    checkBoxClicked: (vehicle: { make: string; model: string }) => void;
    img?: string | undefined;
    dropdownData: MakeFilterUiOject;
}) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const makeClicked = () => {
        checkBoxClicked({ make: value, model: '' });
    };
    const modelCheckBoxClicked = (modelValue: string) => {
        checkBoxClicked({ make: value, model: modelValue });
    };
    return (
        <div
            className={`w-full p-3 space-y-1 border border-gray-200 rounded-lg ${
                selected ? 'border-green-600 bg-green-50' : ''
            }`}
        >
            <div className="flex items-center justify-between">
                <div
                    onClick={() => makeClicked()}
                    className="w-full cursor-pointer flex items-center gap-3"
                >
                    <CustomCheckBox
                        selected={selected}
                        checkBoxClicked={makeClicked}
                    />
                    <div className="flex items-center gap-1.5">
                        {img && (
                            <Image
                                width={28}
                                height={28}
                                quality={80}
                                className="w-7"
                                src={img}
                                alt={text}
                            />
                        )}
                        <Typography className="text-gray-700 text-captionMedium md:text-body2Medium">
                            {t(text as unknown as TemplateStringsArray)}
                        </Typography>
                    </div>
                </div>

                <Image
                    width={10}
                    height={18}
                    style={{
                        transform: isOpen ? 'scaleY(-1)' : 'scaleY(1)',
                        cursor: 'pointer',
                        width: '10px',
                        height: '18px',
                    }}
                    onClick={() => setIsOpen(!isOpen)}
                    src={ArrowDarkDown.src}
                    alt="arrow"
                />
            </div>
            <div
                className={`transition-all duration-100 overflow-auto ${
                    isOpen ? 'h-fit' : 'h-0'
                }`}
            >
                {dropdownData.models.map(model => (
                    <div key={model.text} className="mb-2">
                        <CheckBoxGroup
                            text={model.text}
                            selected={model.selected}
                            checkBoxClicked={modelCheckBoxClicked}
                            value={model.value}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FilterMultiSelect;
